import React from 'react';
import { CFormCheck, CFormFeedback, CFormLabel } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TooltipWithIcon from '../Tooltips/TooltipWithIcon';

const SimpleRadiosGroup = ({
     name,
     label,
     radios,
     isRequired,
     value,
     error,
     setFieldValue,
     disabled,
     className,
     classRadioGroup,
     classNameLabel,
     handleChange,
}) => {
     return (
          <div className={`form-group simple-radios${className ? ` ${className}` : ''}`}>
               {label && (
                    <CFormLabel className={classNameLabel}>
                         <span className="me-1">{label}</span>
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
               )}

               {radios && (
                    <div className={`radios-group-wrapper ${classRadioGroup}`}>
                         {radios.map((radio) => (
                              <div key={radio.value} className="d-flex">
                                   <CFormCheck
                                        id={`${name}-${radio.value}`}
                                        name={name}
                                        value={radio.value}
                                        label={radio.label}
                                        type="radio"
                                        invalid={isRequired && !!error}
                                        checked={radio.value === value}
                                        onChange={handleChange ?? (() => setFieldValue(name, radio.value))}
                                        disabled={disabled}
                                        //TP-195 add test mode, remove in production, add className isCorrect
                                        className={classNames('d-flex align-items-center', { isCorrect: radio.isCorrect === 'yes' })}
                                   />
                                   {radio.contentToolTip && (
                                        <TooltipWithIcon
                                             content={<div dangerouslySetInnerHTML={{ __html: radio.contentToolTip }} />}
                                             trigger="click"
                                        />
                                   )}
                              </div>
                         ))}
                    </div>
               )}
               {isRequired && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

SimpleRadiosGroup.propTypes = {
     name: PropTypes.string,
     label: PropTypes.string,
     radios: PropTypes.array,
     isRequired: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     setFieldValue: PropTypes.func,
     disabled: PropTypes.bool,
     className: PropTypes.string,
     classRadioGroup: PropTypes.string,
};

SimpleRadiosGroup.defaultProps = {
     value: '',
     classRadioGroup: 'd-flex align-items-center',
};

export default SimpleRadiosGroup;
